import React from 'react'
import Placeholder from '../misc/placeholder'
import SectionTableVertical from './SectionTableVertical'


const Entities = (props) => {
    const { type, data, Total, Title } = props

    const cols = [
        {
            label: 'Acronym'
        },
        {
            label: 'Name',
            id: 'LegalName'
        },
        {
            label: 'Board Meeting',
            id: 'BoardMeeting'
        },
        {
            label: 'Stage'
        },
        {
            label: 'ESS'
        }
    ]
    return data ? (
        <React.Fragment>
            <a className="anchor" href="/" id={`section-${type}`}>{' '}</a>
            <SectionTableVertical data={data} cols={cols} labelCol="Acronym" Title={Title} />
            <section className="section d-none d-sm-block">
                <h3 className="section-header">{Title || 'List of AEs'}{Total && ` (${data ? data.length : 0})`}</h3>
                <div className="table-responsive">
                    {data && data.length ? (
                        <table className="table table-hover table-striped">
                            <thead>
                                <tr>
                                    <th>Acronym</th>
                                    <th>Name</th>
                                    <th>Board Meeting</th>
                                    <th>Stage</th>
                                    <th>ESS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.map((d, idx) => (
                                    <tr key={idx}>
                                        <td><strong>{d.Acronym}</strong></td>
                                        <td>{d.LegalName}</td>
                                        <td>{d.BoardMeeting}</td>
                                        <td>{d.Stage}</td>
                                        <td>{d.ESS}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                            <p>No data for this category.</p>
                        )}
                </div>
            </section>
        </React.Fragment>
    ) : <Placeholder />
}

export default Entities